import { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import * as React from "react";

const User: React.FC<IconPresentationProps> = props => {
    return (
        <svg 
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
        
        <circle  cx="11.97" cy="7.47" data-name="&lt;Path&gt;" id="_Path_" r="5.47"/>
        <path d="m1.91,22.75l0,0a9.66,9.66 0 0 1 9.66,-9.66l0.8,0a9.66,9.66 0 0 1 9.66,9.66l0,0"/>
            
        </svg>
    );
};

export default User;
